import { render, staticRenderFns } from "./Tesis.vue?vue&type=template&id=3bfa21a3&scoped=true"
import script from "./Tesis.vue?vue&type=script&lang=js"
export * from "./Tesis.vue?vue&type=script&lang=js"
import style0 from "./Tesis.vue?vue&type=style&index=0&id=3bfa21a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa21a3",
  null
  
)

export default component.exports